export default "__VITE_ASSET__BNKnRyE0__"